import { motion } from 'framer-motion';
import { ExternalLink, Heart } from 'lucide-react';
import invitaionsc1 from './invitationsc1.jpg';
import invitationsc2 from './invitationsc2.jpg';
import invitationsc3 from './invitationsc3.jpg';
import invitationsc4 from './invitationsc4.jpg';

const portfolioItems = [
  {
    id: 1,
    title: 'Jhon & Mary',
    type: 'Wedding Website',
    image: invitaionsc1,
    gridClass: 'md:col-span-8 md:row-span-2',
    link: 'https://jhon-weds-mary.vercel.app/',
    hasVideo: false,
  },
    {
    id: 2,
    title: 'Priya and Ashwin',
    type: 'Wedding Website',
    image: invitationsc3,
    gridClass: 'md:col-span-4 md:row-span-2',
    link: 'https://priya-weds-ashwin.vercel.app/',
    hasVideo: false,
  },
  {
    id: 3,
    title: 'Aravi Turns 1',
    type: 'Birthday Website',
    image: invitationsc2,
    gridClass: 'md:col-span-4 md:row-span-2',
    link: 'https://aravi-birthday-invitation.vercel.app/',
    hasVideo: false,
  },
  {
    id: 4,
    title: "Shopia & Alexander",
    type: 'Wedding Website',
    image: invitationsc4,
    gridClass: 'md:col-span-8 md:row-span-2',
    link: 'https://shopia-weds-alexander.vercel.app/',
    hasVideo: false,
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 40, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] },
  },
};

export default function PortfolioGallery() {
  const handleImageClick = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <section
      id="portfolio"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ backgroundColor: 'var(--bg-surface)' }}
      data-testid="portfolio-section"
    >
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-80 h-80 blob-pink float-anim opacity-30 pointer-events-none" />
      <div className="absolute bottom-20 left-0 w-64 h-64 blob-pink float-anim-reverse opacity-20 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        {/* Section Header */}
        <motion.div
          className="mb-16 md:mb-20"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="flex items-center gap-2 mb-4">
            <Heart size={14} style={{ color: 'var(--primary)' }} className="fill-current" />
            <p
              className="font-body text-xs font-semibold uppercase tracking-[0.2em]"
              style={{ color: 'var(--text-accent)' }}
            >
              Selected Work
            </p>
          </div>
          <h2
            className="font-heading text-4xl md:text-5xl font-light tracking-tight leading-tight"
            style={{ color: 'var(--text-primary)' }}
            data-testid="portfolio-heading"
          >
            A collection of digital
            <br />
            <span className="italic" style={{ color: 'var(--primary)' }}>celebrations</span>
          </h2>
        </motion.div>

        {/* Bento Grid */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-12 gap-6"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
        >
          {portfolioItems.map((item) => (
            <motion.div
              key={item.id}
              className={`${item.gridClass} group relative overflow-hidden rounded-2xl cursor-pointer card-lift`}
              style={{ minHeight: '360px' }}
              variants={itemVariants}
              data-testid="portfolio-grid-item"
              onClick={() => handleImageClick(item.link)}
            >
              {/* Image */}
              <img
                src={item.image}
                alt={item.title}
                  className={`absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110 ${
    item.id === 2 ? 'object-[50%_20%]' : 'object-center'
  }`}
              />

              {/* Gradient Overlay */}
              <div className="bento-overlay absolute inset-0 transition-opacity duration-500" />

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <p className="font-body text-xs font-semibold uppercase tracking-[0.15em] text-white/70 mb-2">
                  {item.type}
                </p>
                <div className="flex items-end justify-between">
                  <h3 className="font-heading text-2xl md:text-3xl font-normal text-white tracking-tight">
                    {item.title}
                  </h3>
                  <motion.div
                    className="flex-shrink-0 ml-4 bg-white/10 backdrop-blur-sm p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    whileHover={{ scale: 1.2, rotate: -15 }}
                  >
                    <ExternalLink size={16} className="text-white" />
                  </motion.div>
                </div>
              </div>

              {/* Hover pink accent line */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#D4587A] to-[#E8739A] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
